module.exports = __webpack_public_path__ + "img/teachercreation.a35a361f.png";